import { useHistory } from "react-router-dom"

import { LocationState } from "@/protocols/history"

const useAuthReturnUrl = () => {
	const history = useHistory()

	const redirectToSignInWithReturnUrl = () => {
		history.push("/signin", { prevUrl: window.location.href })
	}

	const resolveReturnUrl = (): string | undefined => {
		const locationState = history.location.state as LocationState | undefined

		return locationState?.prevUrl
	}

	return {
		redirectToSignInWithReturnUrl,
		resolveReturnUrl
	}
}

export default useAuthReturnUrl
